
/**
 * Module dependencies.
 */

import { throttle } from 'lodash';
import { useEffect, useState } from 'react';

/**
 * `WindowScroll` type.
 */

type WindowScroll = {
  isNavbarFixed: boolean;
};

/**
 * Export `useWindowScroll` hook.
 */

export function useWindowScroll(): WindowScroll {
  const [isNavbarFixed, setNavbarFixed] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = throttle(() => {
      setNavbarFixed(window.scrollY > 150);
    }, 250);

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return {
    isNavbarFixed
  };
}
